<script>
import httpService from '@/core/api/request'
export default {
  data: function () {
    return {
      link_types: null
    }
  },
  methods: {
    getLinkTypes: function () {
      let httpRequest = {
        params: '',
        module: 'link_types'
      }
      this.get(httpRequest)
        .then(
          link_types => {
            this.link_types = link_types.data
          }
        ).catch(
          () => {
            this.link_types = null
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery_images/mixins.vue